<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h3>{{ Object.entries(this.data).length === 0 ? "Add New" : "Edit" }} Tutorial</h3>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <div class="mb-2">
          <vs-input
            label="Name"
            v-model="name"
            class="w-full mb-5"
            name="name"
            v-validate="'required'"
            data-vv-as="Name"/>
          <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
        </div>

        <div class="mb-2">
          <vs-input
            label="Video Link"
            v-model="videoLink"
            class="w-full mb-5"
            name="videoLink"
            v-validate="'required'"
            data-vv-as="Video Link"/>
          <span class="text-danger text-sm" v-show="errors.has('videoLink')">{{ errors.first('videoLink') }}</span>
        </div>

        <div class="mb-2">
          <vs-input
            label="Length"
            v-model="length"
            class="w-full mb-5"
            name="length"
            v-validate="'required'"
            data-vv-as="Length"/>
          <span class="text-danger text-sm" v-show="errors.has('length')">{{ errors.first('length') }}</span>
        </div>

        <!--<vs-input label="Redirect Link" v-model="redirectLink" class="w-full mb-5" name="redirectLink" validate="required"/>
        <span class="text-danger text-sm" v-show="errors.has('redirectLink')">{{ errors.first('redirectLink') }}</span>
-->
        <div class="vx-col w-full mt-5 vs-con-loading__container">
          <template v-if="logo">
            <!-- Image Container -->
            <div class="img-container-tutorial w-64 mx-auto flex items-center justify-center">
              <img :src="logo" alt="img" class="responsive">
            </div>

            <!-- Image upload Buttons -->
            <div class="modify-img flex justify-between my-5">
              <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
              <vs-button class="mr-4"  @click="$refs.updateImgInput.click()">Update Image</vs-button>
              <vs-button color="danger" @click="logo = null">Remove Image</vs-button>
            </div>
          </template>

          <div class="upload-img my-5" v-if="!logo">
            <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button @click="$refs.uploadImgInput.click()">Upload Image</vs-button>
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-between p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button class="vs-button-secondary" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import vSelect from 'vue-select'
  import {mapActions} from "vuex";

  export default {
    data() {
      return {
        dataId: null,
        name: "",
        videoLink: "",
        length: "",
        // redirectLink:"",
        logo: null,
        image: null,
        settings: { // perfect scrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
        customError: "",
      }
    },
    props: {
      isSidebarActive: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        default: () => {
        },
      },
    },
    watch: {
      isSidebarActive(val) {
        if (!val) return
        if (Object.entries(this.data).length === 0) {
          this.initValues()
          this.$validator.reset()
        } else {
          this.dataId = this.data._id
          this.name = this.data.name
          this.videoLink = this.data.videoLink
          this.length = this.data.length
          // this.redirectLink = this.data.redirectLink
          this.image = this.data.image
          this.logo = this.data.image
          this.initValues()
        }
      },
    },
    computed: {
      isSidebarActiveLocal: {
        get() {
          return this.isSidebarActive
        },
        set(val) {
          if (!val) {
            this.$emit('closeSidebar')
          }
        }
      },
      isFormValid() {
        return !this.errors.any()
          && this.name
          && this.videoLink
          && this.length
          // && this.redirectLink
          && this.logo
      }
    },
    methods: {
      ...mapActions("tutorial", [
        "updateTutorial",
        "addTutorial"
      ]),
      showMessage(title, message, color) {
        this.$vs.notify({
          title: title,
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: color
        })
      },
      initValues() {
        if (this.data._id) return
        this.dataId = null
        this.name = ""
        this.videoLink = ""
        this.length = ""
        // this.redirectLink = ""
        this.logo = null
        this.image = null

      },
      updateCurrImg(input) {
        if (input.target.files && input.target.files[0]) {
          this.image = input.target.files[0];
          var reader = new FileReader()
          reader.onload = e => {
            this.logo = e.target.result
          }
          reader.readAsDataURL(input.target.files[0])
        }
      },
      async submitData() {
        await this.$validator.validateAll().then(result => {
          if (result) {
            let data = new FormData();
            data.append('id', this.dataId);
            data.append('name', this.name);
            data.append('videoLink', this.videoLink);
            data.append('length', this.length);
            // data.append('redirectLink', this.redirectLink);
            data.append('image', this.image);
            this.customError = "";
            if (this.dataId !== null) {
              this.$vs.loading()
              this.updateTutorial(data)
                .then((res) => {
                  if (res.status === 200) {
                    this.showMessage("Success", "Tutorial updated successfully.", "success");
                    this.$emit('refreshData', true);
                  }
                  this.$vs.loading.close()
                })
                .catch(err => {
                  this.$vs.loading.close()
                  //console.error(err)
                })
            } else {
              if (this.logo == null) {
                this.customError = "Image is required.";
                return;
              }
              this.$vs.loading()
              this.addTutorial(data)
                .then((res) => {
                  if (res.status === 200) {
                    this.$vs.loading.close()
                    this.$emit('refreshData', true)
                    this.showMessage("Success", "Tutorial added successfully.", "success");
                  }
                })
                .catch(err => {
                  this.$vs.loading.close()
                  if(err.response.status === '422') {
                    this.showMessage("Failed", err.response.data.message, "danger");
                  }
                  this.showMessage("Failed","Failed to add Tutorial", "danger");
                  // console.error(err)
                })
            }
            this.$emit('closeSidebar')
            //this.initValues()
          }
        })
      },
    },
    created(){
    },
    components: {
      vSelect,
      VuePerfectScrollbar,
    }
  }
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
  }
</style>
